// --------------------------------------------------------------------------
export const weightFormatter = (amount: number) => {
    const formatter = new Intl.NumberFormat(`en-US`, {
        style: `unit`,
        unit: `gram`,
        unitDisplay: `long`,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });
    return formatter.format(amount);
};
// --------------------------------------------------------------------------
export const egpCurrencyFormatter = (amount: number) => {
    const formatter = new Intl.NumberFormat(`en-US`, {
        style: `currency`,
        currency: `EGP`,
    });
    return formatter.format(amount);
};
// --------------------------------------------------------------------------
export const dateFormatter = (date: string) => {
    const formatter = new Intl.DateTimeFormat(`en-US`, {
        year: `numeric`,
        month: `long`,
        day: `numeric`,
    });
    return date ? formatter.format(new Date(date)) : "N/A";
};
// --------------------------------------------------------------------------
export const timeFormatter = (date: string) => {
    const formatter = new Intl.DateTimeFormat(`en-US`, {
        hour: `2-digit`,
        minute: `2-digit`,
    });
    return date ? formatter.format(new Date(date)) : "N/A";
};
// --------------------------------------------------------------------------
export const numberFormatter = (amount: number) => {
    const formatter = new Intl.NumberFormat(`en-US`, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    return formatter.format(amount);
}
// --------------------------------------------------------------------------
export const egpCurrencyFormatterFromString = (amount: string) => {
    const formatter = new Intl.NumberFormat(`en-US`, {
        style: `currency`,
        currency: `EGP`,
    });
    const numericAmount = parseFloat(amount);
    if (isNaN(numericAmount)) {
        return 'N/A';
    }
    return formatter.format(numericAmount);
}
// --------------------------------------------------------------------------

